/**
 * The material movement the number keypad is collecting a quantity for.
 * Used to phrase the Stock Material and Transfer Material prompts.
 */
export type QuantityPromptAction = 'stock' | 'transfer';

/**
 * Builds the message shown above the number keypad when a Tool Tracker field
 * user enters a quantity to stock or transfer.
 *
 * `availableQuantity` is intentionally typed as `number` (not a signal): the
 * caller must read the signal's value — `buildQuantityPromptMessage('stock',
 * this.cageQty())` — before passing it in. This is the structural guard against
 * bug #30040, where a signal getter was interpolated directly into the string
 * and rendered as its source ("() => signalGetFn(node)") instead of the number.
 */
export function buildQuantityPromptMessage(
  action: QuantityPromptAction,
  availableQuantity: number
): string {
  return `Please enter a quantity to ${action}. \n Available Quantity: ${availableQuantity}`;
}
